import { render, staticRenderFns } from "./pick-up.vue?vue&type=template&id=5a62f8fd&"
import script from "./pick-up.vue?vue&type=script&lang=js&"
export * from "./pick-up.vue?vue&type=script&lang=js&"
import style0 from "./pick-up.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports